import { render } from "./SelectLanguage.vue?vue&type=template&id=72dbf190&scoped=true"
import script from "./SelectLanguage.vue?vue&type=script&lang=js"
export * from "./SelectLanguage.vue?vue&type=script&lang=js"

import "./SelectLanguage.vue?vue&type=style&index=0&id=72dbf190&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72dbf190"]])

export default __exports__